// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main[data-v-078753dd] {\n  /*50 = navbar  */\n  min-height: calc(100vh - 6.25rem);\n  height: calc(100vh - 6.25rem);\n  width: 100%;\n  position: relative;\n  overflow: scroll;\n}\n.fixed-header + .app-main[data-v-078753dd] {\n  padding-top: 3.125rem;\n}", ""]);
// Exports
module.exports = exports;
